@let fieldData = field();
@let value = fieldData.requestFieldValue || '—';

<div class="flex items-center justify-between mb-6">
  <div [class.font-extrabold!]="fieldData.isHighlighted">
    <p class="x-text-dark-main x-font-body-4">{{ value }}</p>
    <p class="x-text-dark-75 x-font-body-5">
      {{ $displayTitle() }}
    </p>
  </div>

  <x-text-copier
    class="copy-button"
    [textToCopy]="value.toString()"
    size="m"
    appearance="flat"
  ></x-text-copier>
</div>
